import n, { useState as y, useRef as N, useMemo as $, useEffect as W } from "react";
import l from "classnames";
import { mintelGray300 as Z, mintelWhite as J, mintelGray400 as Q } from "mintel-tokens";
import { u as Y } from "../utils-C0l876fA.es.js";
import { u as ee } from "../ThemeProvider--i7ESlT5.es.js";
import { u as te } from "../DarkModeProvider-xoZXm3ct.es.js";
import { I as ne } from "../InputError-BEWrKIXS.es.js";
import { I as oe } from "../InputLabel-CinetSzC.es.js";
import { I as O } from "../Icon-ByeAHRM4.es.js";
import { t as ce } from "../utils-Ci4OZEP4.es.js";
import { w as re } from "../withTheme-zx3wTAWo.es.js";
import { w as ae } from "../context-B284KgoM.es.js";
import '../index7.css';const le = "1.125rem", ue = "1.25rem", _e = "TextInput-compere-module__container___oZCWu", se = "TextInput-compere-module__inTextInputSelectWrapper___CRBzV", ie = "TextInput-compere-module__inTextInputSelect___E2gin", me = "TextInput-compere-module__absoluteRight___95yHr", Ie = "TextInput-compere-module__absoluteLeft___S6pd-", pe = "TextInput-compere-module__clearIcon___bLvwF", de = "TextInput-compere-module__invisible___XIIAr", fe = "TextInput-compere-module__label___AnLts", xe = "TextInput-compere-module__required___zBKYP", Te = "TextInput-compere-module__input___VUaNe", he = "TextInput-compere-module__errorOutline___jm0U5", be = "TextInput-compere-module__dark___VLiCH", Se = "TextInput-compere-module__disabled___-D5RS", $e = "TextInput-compere-module__hasActionIconLeft___2-fbD", ge = "TextInput-compere-module__hasActionIconRight___B4jzz", Re = "TextInput-compere-module__hasClearIcon___qBpu5", Le = "TextInput-compere-module__actionIcon___gmyVx", ve = {
  actionIconSize: le,
  clearIconSize: ue,
  container: _e,
  inTextInputSelectWrapper: se,
  inTextInputSelect: ie,
  absoluteRight: me,
  absoluteLeft: Ie,
  clearIcon: pe,
  invisible: de,
  label: fe,
  required: xe,
  input: Te,
  errorOutline: he,
  dark: be,
  disabled: Se,
  hasActionIconLeft: $e,
  hasActionIconRight: ge,
  hasClearIcon: Re,
  actionIcon: Le
}, ze = "1.125rem", Ce = "1.25rem", Ee = "TextInput-default-module__container___9WBqZ", Ae = "TextInput-default-module__inTextInputSelectWrapper___Xe-Bi", ke = "TextInput-default-module__inTextInputSelect___holP7", ye = "TextInput-default-module__absoluteRight___23w7U", Ne = "TextInput-default-module__absoluteLeft___44yHG", We = "TextInput-default-module__clearIcon___7db6-", Oe = "TextInput-default-module__invisible___Nuzse", qe = "TextInput-default-module__label___3224y", we = "TextInput-default-module__required___6X-3l", Me = "TextInput-default-module__input___Adrc4", Xe = "TextInput-default-module__errorOutline___XmhS0", Ge = "TextInput-default-module__dark___-ce3X", Ue = "TextInput-default-module__disabled___kGL5u", je = "TextInput-default-module__hasActionIconLeft___US9RA", Be = "TextInput-default-module__hasActionIconRight___33gVD", De = "TextInput-default-module__hasClearIcon___41QC1", Fe = "TextInput-default-module__actionIcon___ajTVJ", q = {
  actionIconSize: ze,
  clearIconSize: Ce,
  container: Ee,
  inTextInputSelectWrapper: Ae,
  inTextInputSelect: ke,
  absoluteRight: ye,
  absoluteLeft: Ne,
  clearIcon: We,
  invisible: Oe,
  label: qe,
  required: we,
  input: Me,
  errorOutline: Xe,
  dark: Ge,
  disabled: Ue,
  hasActionIconLeft: je,
  hasActionIconRight: Be,
  hasClearIcon: De,
  actionIcon: Fe
}, He = {
  compere: ve,
  default: q
}, Ve = (o, p, c = !1) => o && document.activeElement !== p.current ? c ? Z : J : Q, Ke = (o) => o === "password" ? "text" : o, Pe = (o) => ["decimal", "numeric"].includes(o) ? "number" : o, Ze = ({
  inTextInputSelect: o,
  className: p,
  disabled: c,
  error: u,
  focused: d,
  icon: f = {
    name: "search",
    disabled: !1,
    label: "search"
  },
  iconAlign: _ = "left",
  id: g,
  ariaDescribedBy: x,
  ariaLabelledBy: T,
  label: s,
  showLabel: w,
  name: M,
  onBlur: X = () => [],
  onChange: G = () => [],
  onClear: U = () => [],
  onFocus: j = () => [],
  onSubmit: h = () => [],
  password: B,
  placeholder: D,
  showClear: R = !0,
  showIcon: m = !0,
  size: F,
  style: H,
  value: a,
  required: L,
  type: v = "text"
}) => {
  const V = ee(), I = te(), { t: K } = Y(), e = He[V] || q, [b, S] = y(a ?? ""), [P, z] = y(!1), C = N(a), r = N(null), E = $(
    () => Ve(I, r, c),
    // dependent on resetIconColor because document.activeElement changes do not trigger re-render
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [I, c, r, P]
  );
  W(() => {
    d && !c && r.current && (r.current.focus(), r.current.select());
  }, [d, c]), W(() => {
    a !== C.current && (C.current = a, S(a ?? ""));
  }, [a]);
  const A = /* @__PURE__ */ n.createElement(
    "button",
    {
      className: l(
        e.actionIcon,
        _ === "left" && e.absoluteLeft
      ),
      onClick: () => {
        h && h({ target: r });
      },
      "aria-label": f.label,
      disabled: !!f.disabled,
      type: "button"
    },
    /* @__PURE__ */ n.createElement(O, { name: f.name, size: e.actionIconSize, color: E })
  ), i = $(
    () => g ?? (s ? ce(s) : void 0),
    [g, s]
  ), k = $(() => {
    const t = x ?? T ?? i;
    return t ? `${t}-error-message` : "";
  }, [x, T, i]);
  return /* @__PURE__ */ n.createElement(
    "div",
    {
      className: l(
        o && e.inTextInputSelectWrapper
      )
    },
    w && i && /* @__PURE__ */ n.createElement(
      oe,
      {
        label: s,
        dark: I,
        inputId: i,
        required: L
      }
    ),
    /* @__PURE__ */ n.createElement(
      "div",
      {
        className: l({
          [e.errorOutline]: !!u
        })
      },
      /* @__PURE__ */ n.createElement("div", { className: l(e.container, p), style: H }, m && _ === "left" && A, /* @__PURE__ */ n.createElement(
        "input",
        {
          type: B ? "password" : Pe(v),
          inputMode: Ke(v),
          ref: r,
          name: M,
          id: i,
          "aria-invalid": !!u,
          "aria-describedby": `${k ?? ""} ${x ?? ""}`,
          "aria-labelledby": T,
          "aria-label": s,
          className: l(
            e.input,
            m && _ === "left" && e.hasActionIconLeft,
            m && _ === "right" && e.hasActionIconRight,
            R && e.hasClearIcon,
            u && e.errorOutline,
            o && e.inTextInputSelect,
            c && e.disabled,
            I && e.dark
          ),
          onBlur: (t) => {
            X(t), z(!1);
          },
          onFocus: (t) => {
            j(t), z(!0);
          },
          onChange: (t) => {
            S(t.target.value), G(t);
          },
          value: b,
          placeholder: D,
          onKeyDown: (t) => {
            t.key === "Enter" && h(t);
          },
          disabled: c,
          autoFocus: d,
          size: F,
          required: L
        }
      ), /* @__PURE__ */ n.createElement("span", { className: e.absoluteRight }, R && /* @__PURE__ */ n.createElement(
        "button",
        {
          className: l(
            e.clearIcon,
            !b && e.invisible
          ),
          onClick: () => {
            S(""), U();
          },
          disabled: !b,
          type: "button",
          "aria-label": K("clear")
        },
        /* @__PURE__ */ n.createElement(
          O,
          {
            name: "close",
            size: e.clearIconSize,
            color: E
          }
        )
      ), m && _ === "right" && A))
    ),
    u && /* @__PURE__ */ n.createElement(ne, { id: k }, u)
  );
}, _t = ae(re(Ze));
export {
  _t as default
};
